import { render, staticRenderFns } from "./addLabelDialog.vue?vue&type=template&id=438acbcc&scoped=true&"
import script from "./addLabelDialog.vue?vue&type=script&lang=js&"
export * from "./addLabelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438acbcc",
  null
  
)

export default component.exports